if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}
const prevArrowHTML = `<button class="slick-arrow slick-prev" aria-label="Prev">
        <svg class="slick-paw" width="28" height="31" viewBox="0 0 201 223"><use href="/assets/svg/paw1.svg#paw-ref1" /></svg>
        <svg class="slick-icon" width="48" height="48" viewBox="0 0 50 50"><path fill="none" stroke-width="2.4" stroke="currentColor" d="M 32 12 L 18 25 L 32 38" /></svg>
        <span>Prev</span>
    </button>`;
const nextArrowtHTML = `<button class="slick-arrow slick-next" aria-label="Next">
        <svg class="slick-paw" width="28" height="31" viewBox="0 0 201 223"><use href="/assets/svg/paw1.svg#paw-ref1" /></svg>
        <svg class="slick-icon" width="48" height="48" viewBox="0 0 50 50"><path fill="none" stroke-width="2.4" stroke="currentColor" d="M 18 12 L 32 25 L 18 38" /></svg>
        <span>Next</span>
    </button>`;

const slickOptions = {
	accessibility: false,
	prevArrow: prevArrowHTML,
	nextArrow: nextArrowtHTML,
};

(function () {
	// TOGGLE TARGET
	document.querySelectorAll('[data-toggleid]').forEach((item) => {
		const target = document.getElementById(item.dataset.toggleid);

		if (target) {
			item.addEventListener('click', () => {
				target.classList.toggle('active');
			});
		}
	});

	// HOME MAP
	document.querySelectorAll('.locationModule').forEach((mod) => {
		mod.querySelectorAll('[data-id*="hpin"]').forEach((btn) => {
			btn.addEventListener('mouseover', () => {
				mod.querySelectorAll('[data-id*="hpin"]').forEach((bt) => bt.classList.remove('active'));
				mod.querySelectorAll(`[data-id="${btn.dataset.id}"]`).forEach((bt) => bt.classList.add('active'));
			});
		});
	});

	/*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	// Remove .text p widows
	const textP = document.querySelectorAll('.text p, .text-modules p') || [];
	const containsHTML = (str) => /<[a-z][\s\S]*>/i.test(str);
	textP.forEach((p) => {
		const lastWords = p.innerHTML.trim().split(' ').slice(-2).join(' ');
		const lastWordsFormatted = lastWords.replace(' ', '&nbsp;');

		if (!containsHTML(lastWords)) p.innerHTML = p.innerHTML.replace(lastWords, lastWordsFormatted);
	});

	// WRAP MODULE TABLES
	document.querySelectorAll('.tableModule table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableModule_wrap');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	$('.sym-slides').slick(slickOptions);

	$('.js-slick-prev').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickPrev');
	});

	$('.js-slick-next').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickNext');
	});
})();
